import supportConfig from './feature/support'

const helpConfig = {
  researchHelp: supportConfig.help.consultationUrls,
}

export default helpConfig
